var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Big_Icons",
    "data-name": "Big Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.24,35.37L40.76,27.332V43.407l-3.5,3.445H13.91l-3.5-3.445Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_4",
    "data-name": "Rounded Rectangle 4",
    className: "cls-2",
    d: "M40.511,15.012V42.167a3.326,3.326,0,0,1-3.3,3.351H13.79a3.326,3.326,0,0,1-3.3-3.351V7.231A3.745,3.745,0,0,1,14.5,3.473H31"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 19.156,
    cy: 26.75,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4_copy",
    "data-name": "Ellipse 4 copy",
    className: "cls-3",
    cx: 19.156,
    cy: 37.094,
    r: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_4_copy",
    "data-name": "Rounded Rectangle 4 copy",
    className: "cls-2",
    d: "M29.779,2.671V12.955A4.46,4.46,0,0,0,33.755,17h8.172"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.454,3.061l10.1,12.948"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPages);
export default __webpack_public_path__ + "static/media/pages.203dec91dce3f6aa8540f28ee7b1a6bd.svg";
export { ForwardRef as ReactComponent };